$(function () {
    var $window = $(window);
    var publish = MW.events.publish;
    var $article = $('.js-entry-content');

    var scrollEvents = {
        entries: {},
        firstScroll: function () {
            if (scrollEvents.scrolled) {
                return;
            }
            if ($window.scrollTop() > 2) {
                publish("first_scroll");
                scrollEvents.scrolled = true;
                $window.off('scroll', scrollEvents.firstScroll);
            }
        },
        inEntry: $article.length === 1,

        entryEvents: Mobileweb.debounce(function () {
            MW.elements.$main.find('.js-entry-content').each(function (idx) {
                var $article = $(this);
                var collapsed = $article.find('.read-more').is(':visible');
                scrollEvents.entries[idx] = scrollEvents.entries[idx] || {};
                if (scrollEvents.entryIsVisible && scrollEvents.entries[idx].scrolledToStartOfEntry && scrollEvents.entries[idx].scrolledToMidOfEntry && scrollEvents.entries[idx].scrolledToEndOfEntry) {
                    return;
                }
                var endOfEntry = $article.height();
                var midOfEntry = endOfEntry / 2;
                var viewPortHeight = $window.height();
                var scrolledTo = $window.scrollTop() + viewPortHeight - $article.offset().top;

                if (scrolledTo >= viewPortHeight / 2 && !scrollEvents.entries[idx].scrolledToStartOfEntry) {
                    publish('start_of_entry', $article);
                    scrollEvents.entries[idx].scrolledToStartOfEntry = true;
                }
                if (!collapsed && scrolledTo >= midOfEntry && !scrollEvents.entries[idx].scrolledToMidOfEntry) {
                    publish('middle_of_entry', $article);
                    scrollEvents.entries[idx].scrolledToMidOfEntry = true;
                }
                if (!collapsed && scrolledTo >= endOfEntry && !scrollEvents.entries[idx].scrolledToEndOfEntry) {
                    publish('end_of_entry', $article);
                    scrollEvents.entries[idx].scrolledToEndOfEntry = true;
                }
                if (!scrollEvents.entryIsVisible && scrolledTo >= viewPortHeight / 2 && scrolledTo <= (endOfEntry + viewPortHeight / 2)) {
                    publish('scroll_into_entry', $article);
                }
            });
        }, 100),

        entryInView: Mobileweb.debounce(function () {
            var entryIsVisible = $window.scrollTop() < $article.offset().top + $article.height();
            if (entryIsVisible && !scrollEvents.entryIsVisible) {
                scrollEvents.entryIsVisible = true;
                publish('entry_visible');
            }
            if (!entryIsVisible && scrollEvents.entryIsVisible) {
                scrollEvents.entryIsVisible = false;
                publish('entry_not_visible');
            }
        }, 100),

        alwaysOn: Mobileweb.throttle(function () {
            var $document = $(document);
            var scrolledToBottom = $document.scrollTop() + 600 > $document.height() - $window.height();
            if (scrolledToBottom) {
                publish('scroll_to_bottom');
            }
        }, 100)
    };

    MW.events.subscribe('init_dom_ready', function () {
        if (scrollEvents.inEntry) {
            $window.on('scroll', scrollEvents.entryInView);
        }
        scrollEvents.alwaysOn();
        $window.on('scroll', scrollEvents.alwaysOn);
        $window.on('scroll', scrollEvents.firstScroll);
        $window.on('scroll', scrollEvents.entryEvents);
    });

});
